<template>
  <div>
    <h1>用工报表</h1>
  </div>
</template>
<script>
export default {
  name: 'ChartsLabor',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/report/Labor.vue